<template>
  <div class="outter">
    <div class="inner">
      <img  @click="closed" class="closeimg" src="../../assets/img/closed.png" alt="">
      <div class="titleheader">
        <div class="titlename">教师选书</div>
      </div>
      <div class="middle">
        <div>
          <p class="tti">所选教材</p>
          <div class="modeltop">
            <div class="topleft ">
              <div class="carddiv">
                <img  v-if="infoData.teacherPressInfoVo.coverUrl" class="modelimg" :src="infoData.teacherPressInfoVo.coverUrl" alt="" />
                <img
                  v-else
                  class="modelimg"
                  src="../../assets/img/noimage.jpeg"
                  alt=""
                />
                <div>
                  <p class="bookTitle">{{ infoData.teacherPressInfoVo.teachName }}</p>
                  <p class="commoncss">
                    作者:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{ infoData.teacherPressInfoVo.author }}
                  </p>
                  <p class="commoncss">
                    书号:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {{ infoData.teacherPressInfoVo.isbn }}
                  </p>
                  <p class="commoncss">
                    出版社: {{ infoData.teacherPressInfoVo.publicationName }}
                  </p>
                  <p class="commoncss">
                    定价:<span class="pricecolor"
                      >￥ {{ Number(infoData.teacherPressInfoVo.pricing).toFixed(2) }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="topright">
            <h1 class="bookcourse">
              用书课程
            </h1>
            <div>
              <el-select
              :popper-append-to-body="false"
              class="elSelectnew"
              v-model="formData.facultyId"
              placeholder="请选择院系"
              @change="changeDepartment"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
                class="elSelectnew"
                v-model="formData.specialtyId"
                placeholder="请选择专业"
                @change="changeMajor"
              >
            <el-option
              v-for="item in majorData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
          class="elSelectnew"
          v-model="formData.grade"
          placeholder="请选择年级"
        >
          <el-option
            v-for="item in gradeData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          class="elSelectnewxue"
          v-model="formData.term"
          placeholder="请选择上课学期"
        >
        <el-option
          v-for="item in xueqiData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
          class="elSelectnew"
          v-model="formData.courseId"
          placeholder="请选择课程"
          @change="changeCourse"
        >
            <el-option
              v-for="item in courseData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
      </el-option>
    </el-select>
    <div class="resetcss" @click="resetButton">
      重置
    </div>
            </div>
          </div>
          <div class="modelmiddle">
            <h1 class="bookcourse">
              用书班级
            </h1>
            <div class="checkdiv">
              <p class="tabletitle" v-if="classArr.length==0">温馨提示：请先选择用书课程</p>
              <ul class="ulclea">
                <li
                  class="litable left"
                  :key="item.classId"
                  v-for="(item, index) in classArr"
                >
                <div :key="index">
                  <span class="classnamediv  classtext"
                    >{{ item.name }}
                  </span>
                  :
                  <span class="classtext numcss">{{ item.gradeNumber }}人</span>
                </div>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <h1 class="bookcourse">
              用书时间
            </h1>
            <el-select
              class="elSelectnew1"
              v-model="formData.openSemesterId"
              placeholder=" 请选择用书时间"
            >
              <el-option
                v-for="item in timeData"
                :key="item.id"
                :label="item.semesterStr"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bottomdiv">
          <div class="commonbutton canclebutton" @click="submitCancle">
            取消
          </div>
          <div class="buttonnew commonbutton" @click="submitAction">
            加入选书
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import { queryCourseFaculty ,getMajorList,queryTeacherCourseList,querySchoolSquadList} from '../../api/wapi'
import {
  getCourse,
  getBookInfo,
  bookSave,
  bookEdit,
  hasSemester,
} from '../../api/index.js'
export default {
  props: {
    id: {
      type: String,
      default:''
    },
    pressId: {
      type: String,
      default:''
    },
  },
  inject: ['updateList'],
  data() {
    return {
      xueqiData:[
        {
          id: 1,
          name: '第一学期',
        },
        {
          id: 2,
          name: '第二学期',
        },
      ],
      timeData:[],
      courseData:[],
      majorData:[],
      classArr: [],
      teachCourse: '',
      infoData: {
        teacherPressInfoVo:{
          coverUrl:""
        }
      },
      formData: {
        facultyId: '',
        specialtyId: '',
        term: '',
        openSemesterId:'',
        grade:'',
        courseId:'',
      },
      departmentList:[],
      gradeData:[
        {
          id: 1,
          name: '大学一年级',
        },
        {
          id: 2,
          name: '大学二年级',
        },
        {
          id: 3,
          name: '大学三年级',
        },
        {
          id: 4,
          name: '大学四年级',
        },
        {
          id: 5,
          name: '大学五年级',
        },
      ],
      
    }
  },
  computed: {
    ...mapGetters(['resPhone']),
  },
  created() {
    this.formData.pressId = this.pressId
    let params = {}
    if(this.id){
      params.id = this.id
      params.pressId = this.pressId
    }else{
      params.id = ''
      params.pressId = this.pressId
    }
    this.getBookInfoData(params)
    this.queryCourseFacultyApi()
    this.getUseBook()
  },
  mounted() {},
  methods: {
    resetButton(){
        this.majorData = []
        this.formData.facultyId = ''
        this.formData.specialtyId = ''
        this.formData.grade = ''
        this.formData.term = ''
        this.formData.courseId = ''
        this.courseData = []
        this.classArr = []
    },
    getUseBook(){
      hasSemester().then((res) => {
        if (res.status == 0) {
            this.timeData = res.data
        } 
      })
    },
    queryCourseFacultyApi(){
      queryCourseFaculty().then(res=>{
        if (res.status == 0) {
          this.departmentList = res.data
        }
      })
    },
    changeMajor(value){
      this.formData.courseId = ''
      let params = {
        specialtyId: value,
      }
      this.queryCourse(params,()=>{})
    },
    queryCourse(params,callback){
      queryTeacherCourseList(params).then((res) => {
        if (res.status == 0) {
          this.courseData = res.data
          callback()
        }
      })
    },
    closed(){
      this.$emit('close')
    },
    submitCancle() {
      this.$emit('close')
    },
    changeCourse(value){
      this.formData.classIdsStr = []
      let params = {
        courseId: value,
      }
      this.getBan(params,()=>{})
    },
    getBan(params,callback){
      querySchoolSquadList(params).then(res=>{
        if (res.status == 0) {
          this.classArr = res.data
          callback()
        }
      })
    },
    changeDepartment(value) {
      this.formData.specialtyId = ''
      let params = {
        facultyId: value,
      }
      this.getMajor(params,()=>{})
    },
    getMajor(params,callback){
      getMajorList(params).then((res) => {
        if (res.status == 0) {
          this.majorData = res.data
          callback()
        }
      })
    },
    getBookInfoData(params) {
      getBookInfo(params).then((res) => {
        if (res.status == 0) {
          this.infoData = res.data
          if(params.id){
            this.formData.facultyId = res.data.facultyId
            if(this.formData.facultyId){
              let params = {
                facultyId: this.formData.facultyId,
              }
              this.getMajor(params,()=>{
                this.formData.specialtyId = res.data.specialtyId
              })
            }
            this.formData.grade = res.data.grade
            this.formData.term = res.data.term
            if(res.data.specialtyId){
              let params = {
                specialtyId: res.data.specialtyId,
              }
              this.queryCourse(params,()=>{
                this.formData.courseId = res.data.courseId
              })
            }
            this.formData.openSemesterId = res.data.openSemesterId
            if(res.data.courseId){
              let params = {
                courseId: res.data.courseId,
              }
              this.getBan(params,()=>{})
            }
          }
        }
      })
    },
    submitAction() {

      if(this.formData.facultyId == ''){
        this.$message.error('请选择院系')
        return 
      }
      if(this.formData.specialtyId == ''){
        this.$message.error('请选择专业')
        return 
      }
      if(this.formData.grade == ''){
        this.$message.error('请选择年级')
        return 
      }
      if(this.formData.term == ''){
        this.$message.error('请选择学期')
        return 
      }
      if(this.formData.courseId == ''){
        this.$message.error('请选择课程')
        return 
      }
      if(this.formData.openSemesterId == ''){
        this.$message.error('请选择用书时间')
        return 
      }
      let classStrArr = []
      for (let i in this.classArr) {
          classStrArr.push(this.classArr[i].id)
      }
      this.formData.classIdsStr = classStrArr
      if (this.id) {
        let dataParam = Object.assign({}, this.formData, { id: this.id })
        bookEdit(dataParam).then((res) => {
          if (res.status == 0) {
            this.updateList()
            this.$message.success('编辑成功')
            this.$emit('close')
          }else{
            this.$message.error(res.msg)
          }
        })
      } else {
        bookSave(this.formData).then((res) => {
          if (res.status == 0) {
            this.$message.success('添加成功')
            this.$emit('close')
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style >
  .numcss{
    margin-left: 6px;
  }
  .ulclea::after{
            content: '';
            display: block;
            clear: both;
        }
.resetcss{
  float: right;
  width: 83px;
  height: 36px;
  background: #007AFF;
  border-radius: 4px 4px 4px 4px;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  margin-top: 1px;
  cursor: pointer;
}
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
        background-color: #007AFF !important;
        color: #fff !important;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover  span{
        color: #fff !important;
  }

  .closeimg{
    position: absolute;
    right: -32px;
    top: -22px;
    cursor: pointer;
    z-index: 100;
  }
.titleheader {
  background-color: #ebf6ff;
  text-align: center;
}
.titleicon {
  width: 20px;
  height: 20px;
  object-fit: cover;
}
.titlename {
  line-height: 60px;
  height: 60px;
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.bottomdiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
.inputNumber {
  width: 100px !important;
}
.checkall {
  position: absolute !important;
  right: 20px;
  top: 10px;
}
.elSelectnew {
  width: 143px;
  height: 36px;
  margin-right: 16px;
}
.elSelectnewxue{
  width: 150px;
  height: 36px;
  margin-right: 16px;
}

 
  .el-select-dropdown__list{
      padding: 0 !important;
  }
 .popper__arrow::after{
  top: 0 !important;
}
.elSelectnew1{
  width: 200px;
  height: 36px;
  margin-right: 16px;
}
.elSelectnew .el-input__inner {
  height: 36px;
}
.elSelectnew .el-input__icon {
  line-height:  36px;
}
.checkboxm {
  margin-top: 0px !important;
}
.checkboxm .el-checkbox__input {
  margin-top: 3px !important;
}
</style>
<style lang="scss" >
  .tti{
    margin: 20px 0;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
  }
.checkboxm {
  margin: 0 10px !important;
  width: 300px !important;
  overflow: hidden;
}
.classnamediv {
  max-width: 110px;
  display: inline-block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.mr20 {
  margin-right: 15px;
}
.classtext {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  display: inline-block;
  vertical-align: middle;
}
.litable {
  width: 172px;
  height: 24px;
  box-sizing: border-box;
  line-height: 24px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.checkdiv {
  position: relative;
  background-color: #F6F9FB;
  border-radius: 4px;
  padding: 10px 12px;
}
.tabletitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  font-size: 13px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.modelmiddle {
  background: #ffffff;
  border-radius: 4px;
  overflow-y: auto;
}
.redtext {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #0082f0;
}
.bookcourse {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #010101;
  font-weight: bold;
  margin: 20px 0;
}
.modeltop::after {
  content: '';
  display: block;
  clear: both;
}
.topleft {
}
.modelimg {
  width: 90px;
  height: 120px;
  display: block;
  float: left;
  margin-right: 10px;
}
.pricecolor {
  color: #b80d03;
  font-size: 13px;
}
.commoncss {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bookTitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #010101;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.carddiv {
  height: 120px;
  background: #F6F9FB;
  padding: 10px;
}
.buttonnew {
  background: #007AFF;
  margin-left: 30px;
}
.commonbutton {
  border-radius: 4px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin-top: 24px;
  cursor: pointer;
  float: left;
  width: 100px;
  height: 40px;
}
.canclebutton {
  color: #666666;
  width: 90px;
  height: 36px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E6E6E6;
}
.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-top: 20px;
  margin-bottom: 10px;
}
.middle {
  padding: 60px !important;
  padding-top: 0 !important;
}
.textHeader {
  position: relative;
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
}
.close img {
  width: 14px;
  height: 14px;
}
.modelText {
  width: 330px;
  height: 30px;
  background: #fff8f7;
  padding-left: 22px;
  line-height: 30px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.outter {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0,0,0,0.5);
} 
.inner {
  width: 1005px !important;
  height: 700px !important;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background: #ffffff;
  border: 1px solid #cccccc;
  padding-top: 0;
}
</style>